import { render, staticRenderFns } from "./DealsByCreator.vue?vue&type=template&id=6c11572a&scoped=true&"
import script from "./DealsByCreator.vue?vue&type=script&lang=js&"
export * from "./DealsByCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c11572a",
  null
  
)

export default component.exports